import React from "react";

import Modal from "../../../../components/Modal";

import LoadingComponent from "./lazy";

export default (
    props => (
        <Modal close={props.close} width="800px">
            <LoadingComponent {...props} />
        </Modal>
    )
);
